import { useRef, useState } from "react";
import { CoreButton } from "../button/Button";
import styles from "./CoreUpload.module.css";
import DragAndDropIcon from "./images/drag-and-drop.svg?react";
import CoreFileInput from "./FileInput";

type CoreUploadProps = {
	description?: string;
	buttonText: string;
	onUpload: (files: File[]) => void;
	fileTypes: string;
	className?: string;
	/**@default false */
	multiple?: boolean;
};

export default function CoreUpload({
	description,
	buttonText,
	onUpload,
	fileTypes,
	className,
	multiple = false,
}: CoreUploadProps) {
	const [isDragActive, setIsDragActive] = useState(false);
	const fileInputRef = useRef<HTMLInputElement>(null);

	const handleFileChange = (fileList: FileList | null) => {
		if (!fileList) return;
		let files = Array.from(fileList);

		// If multiple is false, we only care about the first file
		if (!multiple && files.length > 0) {
			files = [files[0]];
		}

		if (files.length > 0) {
			onUpload(files);
		}
	};

	return (
		<div
			className={`${styles.uploadContainer} ${isDragActive ? styles.dragActive : ""} ${className || ""}`}
			onDrop={(event: React.DragEvent) => {
				event.preventDefault();
				setIsDragActive(false);
				handleFileChange(event.dataTransfer.files);
			}}
			onDragOver={(e) => e.preventDefault()}
			onDragEnter={() => setIsDragActive(true)}
			onDragLeave={() => setIsDragActive(false)}
		>
			<DragAndDropIcon color="#969696" />
			{description && <div className={styles.dragAndDropText}>{description}</div>}
			<CoreButton onClick={() => fileInputRef.current?.click()}>
				<CoreFileInput ref={fileInputRef} accept={fileTypes} onChange={onUpload} multiple={multiple} />
				{buttonText}
			</CoreButton>
		</div>
	);
}
